import { useState, useEffect } from 'react';
import { scheduleModelData } from '../services/ModelService';

export default function useAllSchedules() {
    const [allSchedules, setAllSchedules] = useState(null);

    useEffect(() => {
        const loadSchedules = async () => {
            try {
                const schedules = await scheduleModelData.getAll();
                setAllSchedules(schedules);
            } catch (error) {
                console.error('Error loading schedules:', error);
            }
        };

        loadSchedules();
    }, []);

    return { allSchedules };
}
